
import XHeader from 'vux/src/components/x-header/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Box from 'vux/src/components/box/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import Cell from 'vux/src/components/cell/index.vue'


export default {
components: {
XHeader,
XInput,
XTextarea,
XButton,
Box,
Group,
CellBox,
Cell
},
data() {
return {
title: 'API设置',
entity: {
mobile: '',
email: '',
desc: ''
}
}
}
}



// WEBPACK FOOTER //
// ./src/components/usercenter/ApiEdit.vue